export const FAQ_DATA: Record<string, Array<{ q: string; a: string }>> = {
  uk: [
    {
      q: 'Чи потрібно мати релігійну освіту для проходження курсу?',
      a: 'Ні. Курс розроблений для всіх охочих — незалежно від рівня знань і конфесійної приналежності. Тут немає складних богословських термінів, лише живе Слово і чесні запитання.',
    },
    {
      q: 'Скільки часу займає один урок?',
      a: 'Кожен урок розраховано приблизно на 20–30 хвилин. Ви можете проходити у зручному для вас темпі — немає жорстких дедлайнів.',
    },
    {
      q: 'Чи можу я поставити запитання по темі уроку?',
      a: 'Так! Наш служитель відповідає особисто через Telegram або WhatsApp. Просто напишіть після уроку — ми раді спілкуватися.',
    },
    {
      q: 'Чи є можливість поділитися молитовним проханням?',
      a: 'Звісно. В кожному уроці є розділ «Молитовне прохання» — напишіть нам, і ми помолимося разом з вами.',
    },
    {
      q: 'Курс безкоштовний?',
      a: 'Так, повністю безкоштовний. Курс відкритий для всіх без реєстрації карток чи оплати.',
    },
  ],
  ru: [
    {
      q: 'Нужно ли иметь религиозное образование для прохождения курса?',
      a: 'Нет. Курс разработан для всех желающих — независимо от уровня знаний и конфессиональной принадлежности. Здесь нет сложных богословских терминов, только живое Слово и честные вопросы.',
    },
    {
      q: 'Сколько времени занимает один урок?',
      a: 'Каждый урок рассчитан примерно на 20–30 минут. Вы можете проходить в удобном темпе — жёстких дедлайнов нет.',
    },
    {
      q: 'Могу ли я задать вопрос по теме урока?',
      a: 'Да! Наш служитель отвечает лично через Telegram или WhatsApp. Просто напишите после урока — мы рады общению.',
    },
    {
      q: 'Есть ли возможность поделиться молитвенной просьбой?',
      a: 'Конечно. В каждом уроке есть раздел «Молитвенная просьба» — напишите нам, и мы помолимся вместе с вами.',
    },
    {
      q: 'Курс бесплатный?',
      a: 'Да, полностью бесплатный. Курс открыт для всех без регистрации карты или оплаты.',
    },
  ],
}
